// extracted by mini-css-extract-plugin
module.exports = {"lqd0tjb":"lqd0tjb","link":"link","title":"title","description":"description"};